import * as React from 'react';
import { Select, TreeSelect } from '@beehive/components';
import { flatMap } from 'utils';
import _ from 'lodash';

export default class SelectWarp extends React.Component<any, any> {
  public handleChange = (value: any) => {
    const { options, isTree, onChange } = this.props;
    let flatOptions = options;
    if (isTree) {
      flatOptions = flatMap(options);
    }
    const allValues = flatOptions.map((item: any) => item.value);
    const isSelectedAll = !_.xor(allValues, value).length;
    onChange(value, isSelectedAll);
  }
  public render() {
    const { isTree, isMultiple, value, options, mode } = this.props;
    let newValue = value;

    if (isMultiple && newValue === undefined && mode === 'filter') {
      const flatOptions = flatMap(options);
      newValue = flatOptions.map((item: any) => item.value);
    }
    if (isTree) {
      return (
        <TreeSelect {...this.props} onChange={this.handleChange} value={newValue}/>
      );
    } else {
      return (
        <Select {...this.props} onChange={this.handleChange} value={newValue}/>
      );
    }
  }
}
